import { getAxiosInstance } from '../client';
/** Mutation API functions for exercise favourites */
export const exerciseFavouritesMutations = {
    /** POST /exercise-favourites/add */
    add: (dto) => getAxiosInstance()
        .post('/exercise-favourites/add', dto)
        .then((r) => r.data),
    /** POST /exercise-favourites/remove */
    remove: (dto) => getAxiosInstance()
        .post('/exercise-favourites/remove', dto)
        .then((r) => r.data),
};
//# sourceMappingURL=exercise-favourites.mutations.js.map